<ag-grid-angular
  [gridOptions]="internalGridOptions"
  class="ag-theme-alpine flex-grow-1"
  [columnDefs]="columnDefs"
  [rowData]="items"
  [modules]="modules"
  [rowSelection]="rowSelection"
  (selectionChanged)="onSelectionChanged($event)"
  (rowDataChanged)="rowDataChanged()"
  (rowClicked)="rowClickedChanged($event)"
>
</ag-grid-angular>
